export default function tagSearchTextReducer(state, action) {
  switch (action.type) {
    case 'UPDATE_TAG_SEARCH_TEXT':
    case 'ACTIVATE_TAG_SEARCH':
      if (action && action.searchText !== undefined) {
        return {
          ...state,
          tagSearchText: action.searchText,
        };
      }
      return state;
    case 'SET_VIEW':
      if ((action.view === 'resources' && state.view === 'tags')
      || (action.view === 'tags' && state.view === 'resources')) {
        return {
          ...state,
          tagSearchText: '',
        };
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tagSearchText.js